const MUTE_ARRIVED_CHIME_KEY = "adatis.agenda.muteArrivedChime";

export const isArrivedChimeMuted = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(MUTE_ARRIVED_CHIME_KEY) === "1";
  } catch {
    return false;
  }
};

export const setArrivedChimeMuted = (muted: boolean): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (muted) {
      window.localStorage.setItem(MUTE_ARRIVED_CHIME_KEY, "1");
    } else {
      window.localStorage.removeItem(MUTE_ARRIVED_CHIME_KEY);
    }
  } catch {
    // ignore
  }
};

/**
 * Soft success chime when reception marks "Chegou" (no asset; Web Audio).
 * Respects mute preference. Failures are silent (autoplay / unsupported).
 */
export const playArrivedChime = (): void => {
  if (typeof window === "undefined" || isArrivedChimeMuted()) {
    return;
  }

  try {
    const AudioCtx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;

    if (!AudioCtx) {
      return;
    }

    const context = new AudioCtx();
    const now = context.currentTime;

    const playTone = (frequency: number, startAt: number, duration: number) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;
      gain.gain.value = 0.035;
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(startAt);
      gain.gain.exponentialRampToValueAtTime(0.001, startAt + duration);
      oscillator.stop(startAt + duration);
    };

    playTone(523.25, now, 0.12);
    playTone(659.25, now + 0.1, 0.16);
  } catch {
    // ignore
  }
};

/** Horário atrasado ainda ativo (agendado/confirmado, início no passado). */
export const isLateActiveAppointment = (
  appointment: {
    status: string;
    start_datetime: string;
  },
  nowMs: number = Date.now()
): boolean =>
  ["scheduled", "confirmed"].includes(appointment.status) &&
  new Date(appointment.start_datetime).getTime() < nowMs;

/** Atrasado e ainda sem “Chegou”. */
export const isLateArrivableAppointment = (
  appointment: {
    status: string;
    start_datetime: string;
    client_arrived_at?: string | null;
  },
  nowMs: number = Date.now()
): boolean =>
  !appointment.client_arrived_at && isLateActiveAppointment(appointment, nowMs);
